import { BusEvent } from '@web/common';

export class AdminBrandChangedBusEvent extends BusEvent {}
